<template>
  <div class="leave-dialog">
    <div class="box">
      <div class="title">{{ $t("studentProgramme.submitTitle") }}</div>
      <div class="content"></div>
      <div class="content">{{ $t("studentProgramme.submitText1") }}</div>
      <div class="btn" :loading="isSubmitting">
        <el-button type="info"  round @click="returnTo">{{ $t("studentProgramme.cancel") }}</el-button>
        <!-- 根据isSubmitting状态切换显示原始按钮或加载中状态 -->
        <el-button v-if="isSubmitting" type="warning" :loading="isSubmitting" round>{{ $t("studentProgramme.submitting") }}</el-button>
        <el-button v-else type="warning"  round @click="leave" :class="{ disabled: isSubmitting }">{{ $t("studentProgramme.submit") }}</el-button>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isSubmitting: false // 控制提交状态的标志位
    }
  },
  methods: {
    returnTo() {
      this.$emit('closeDialog')
    },

    leave() {
      if (this.isSubmitting) return;

      // 设置为提交中状态
      this.isSubmitting = true;
      this.$emit('confirm')
    }
  }
}
</script>

<style scoped lang="scss">
.leave-dialog {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9;

  .box {
    width: 400px;
    height: 230px;
    background-color: #fff;
    border-radius: 20px;
    display: flex;
    flex-wrap: wrap;
    align-content: space-around;
    padding: 20px 0;
    box-sizing: border-box;
    .title {
      width: 100%;
      font-size: 30px;
      text-align: center;
      color: #B62D2E;
      font-weight: 700;
    }

    .content {
      font-size: 20px;
      width: 100%;
      text-align: center;
      padding-bottom: 30px;
    }

    .btn {
      width: 100%;
      display: flex;
      justify-content: center;

      img {
        height: 50px;
        width: auto;
        margin: 0 10px;
        cursor: pointer;

        &:hover {
          opacity: .7;
        }
      }
    }
  }
}
</style>